// ------------------------------------
// imports
// ------------------------------------
import {
  PROCESS_PARTNER_AUTH_START,
  PROCESS_PARTNER_AUTH_END,
  ERROR_AUTH_PARTNER,
  ACTIVATE_PARTNER_START,
  ACTIVATE_PARTNER_END,
  ERROR_ACTIVATE_PARTNER,
} from 'redux/actions/activatePartner';

// ------------------------------------
// Reducer Handlers
// ------------------------------------
const initialState = {
  isProcessingAuth: false,
  info: {},
  errorAuth: null,
  isActivatingPartner: false,
  errorActivationPartner: null
};

const REDUCER_HANDLERS = {
  [PROCESS_PARTNER_AUTH_START]:  (state, action) => {
    const isProcessingAuth = !action.payload.social;
    return { ...initialState, isProcessingAuth: isProcessingAuth}
  },
  [PROCESS_PARTNER_AUTH_END]: (state, { payload }) => ({ ...initialState, info: payload }),
  [ERROR_AUTH_PARTNER]: (state, { payload }) => ({ ...initialState, errorAuth: payload }),
  [ACTIVATE_PARTNER_START]: state => ({ ...state, isActivatingPartner: true }),
  [ACTIVATE_PARTNER_END]: () => ({ ...initialState, isActivatingPartner: false }),
  [ERROR_ACTIVATE_PARTNER]: (state, { payload }) =>
    ({ ...initialState, isActivatingPartner: false, errorActivationPartner: payload })
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function partnerActivateReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/activatePartner.js